<script setup lang="ts">
import { defineProps, defineEmits, watch, reactive, PropType } from 'vue';
import { useRouter } from 'vue-router';
import { useLanguage } from "../utils/useLanguage";

const { t } = useLanguage();
const router = useRouter();
const emit = defineEmits(['update:title', 'update:content', 'update:status', 'update:msg', 'confirmDelete', 'confirmCancel', 'confirmKick']);

const props = defineProps({
    type: {
        type: String,
        required: false,
    },
    title: {
        type: String,
        required: true,
    },
    content: {
        type: String,
        required: true,
    },
    msg: {
        type: String,
        required: true,
    },
    status: {
        type: Boolean,
        required: false,
    },
    childFunction: {
        type: Function as PropType<(event: MouseEvent) => void>, // Explicitly define the expected function signature
        required: false,
    }
});

const boolChange = () => {
    emit('update:status', false);
};

const refresh = () => {
    location.reload();
};

const modalSetting = reactive({
    status: false, // Modal Open or Close
});

watch(() => props.status, (newStatus) => {
    modalSetting.status = newStatus;
});
</script>

<template>
    <div id="downloadlModal" class="modal fixed p-center" :style="[props.status ? 'display: block': 'display: none']">
        <div class="modalTitle title-2 white-1 flex j-between " :class="!props.type || props.type !== 'alert' ? 'bg-pr':'bg-dark'">{{ t(props.title) }} <div class="icon-close pointer white-1"  @click="props.msg == 'refresh' ? refresh() : boolChange()" v-if="props.msg !== 'reset-password'"></div></div>
        <div class="modalContent bg-white-1 scroll">
            <div class="flex column-sm column a-center gap-20">
                <img class="s-20" src="/icon-checked.png" alt="" v-if="!props.type || props.type !== 'alert'">
                <img class="s-20" src="/icon-alert.png" alt="" v-else>
                <p>{{ t(props.content) }}</p>
            </div>
        </div>
        <div class="modalFooter bg-white-1">
            <div class="t-right">
                <router-link to="/admin/login" class="btn-sm bg-black-3" v-if="props.msg === 'subscribe'">{{ t('Login') }}</router-link>
                <router-link to="/admin/login" class="btn-sm bg-pr" v-if="props.msg === 'registration'">{{ t('Login') }}</router-link>
                <button class="btn-sm bg-pr" v-if="props.msg === 'refresh'" @click="refresh">{{ t('Confirm') }}</button>
                <button class="btn-sm" :class="props.type ? 'bg-black-3' : 'bg-pr'" v-if="props.msg === 'confirm'" @click="boolChange()">{{ t('Confirm') }}</button>
                <router-link to="/admin/login" class="btn-sm bg-pr" v-if="props.msg === 'reset-password'">{{ t('Login') }}</router-link>
                <router-link :to="`/speak/${props.type}`" class="btn-sm bg-pr" v-if="props.msg === 'createdebate'">{{ t('Confirm') }}</router-link>
                <button class="btn-sm bg-pr" v-if="props.msg === 'cancel'" @click="childFunction">{{ t('Confirm') }}</button>
                <button class="btn-sm bg-pr" v-if="props.msg === 'videosuccess'" @click="childFunction">{{ t('Watch') }}</button>
                <button class="btn-sm bg-black-3" v-if="props.msg === 'videofail'" @click="boolChange()">{{ t('Confirm') }}</button>
                
                <div class="flex gap-5 j-end" v-if="props.msg === 'buy-a-ticket'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-black-2" @click="childFunction">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'join-team'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-black-2" @click="childFunction">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'cancel-debate'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Reconsider') }}</button>
                    <button class="btn-sm bg-black-2" @click="childFunction">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'reload'">
                    <button class="btn-sm bg-black-2" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-black-3" v-if="props.msg === 'reload'" @click="refresh(); boolChange()">{{ t('Refresh') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'chatnow'">
                    <router-link to="/admin/register" class="btn-sm bg-black-2">{{ t('Sign up') }}</router-link>
                    <router-link to="/admin/login" class="btn-sm bg-black-3">{{ t('Login') }}</router-link>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'pro'">
                    <router-link to="/subscribe" class="btn-sm bg-sd bold">{{ t('Upgrade Now') }}</router-link>
                    <router-link to="/video" class="btn-sm bg-black-3">{{ t('Cancel') }}</router-link>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'delete-discussion'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-black-2" @click="emit('confirmDelete'); boolChange()">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'delete-sentence'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-black-2" @click="emit('confirmDelete'); boolChange()">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'registration-close'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-dark" @click="emit('confirmDelete'); boolChange()">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'debate-cancel'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-dark" @click="emit('confirmCancel'); boolChange()">{{ t('Confirm') }}</button>
                </div>
                <div class="flex gap-5 j-end" v-if="props.msg === 'kick-member'">
                    <button class="btn-sm bg-black-3" @click="boolChange()">{{ t('Cancel') }}</button>
                    <button class="btn-sm bg-dark" @click="emit('confirmKick'); boolChange()">{{ t('Confirm') }}</button>
                </div>
            </div>
        </div>
    </div>
    <div id="mask" class="mask fixed" :class="modalSetting.status ? 'active' : ''"></div>
</template>

<style scoped>
@import '../assets/css_lib/themimir.css';
</style>
